/**
 * @copyright © Paramount Streaming
 * @author  Stan Gletski
 * @description Page action type literals. Coming in from skin API pageAction method call
 */
export enum PageAction {
	/**
	 * @description Page Live menu click
	 * @type {PageAction.LIVE_MENU_CLICK}
	 */
	LIVE_MENU_CLICK = 'PageAction.LIVE_MENU_CLICK',

	/**
	 * @description Start Page Click simulation from page. Should be used when Start Panel is forced by browser blocking autoplay
	 * @type {PageAction.START_PANEL_CLICK}
	 */
	START_PANEL_CLICK = 'PageAction.START_PANEL_CLICK',

	/**
	 * @description Hide Skin
	 * @type {PageAction.UI_HIDE}
	 */
	UI_HIDE = 'PageAction.UI_HIDE',

	/**
	 * @description Show Skin
	 * @type {PageAction.UI_SHOW}
	 */
	UI_SHOW = 'PageAction.UI_SHOW',

	/**
	 * @description Hide closed captioning
	 * @type {PageAction.CC_HIDE}
	 */
	CC_HIDE = 'PageAction.CC_HIDE',

	/**
	 * @description Show closed captioning
	 * @type {PageAction.CC_SHOW}
	 */
	CC_SHOW = 'PageAction.CC_SHOW',

	/**
	 * @description Mute audio
	 * @type {PageAction.MUTE}
	 */
	MUTE = 'PageAction.MUTE',

	/**
	 * @description Unmute audio
	 * @type {PageAction.UNMUTE}
	 */
	UNMUTE = 'PageAction.UNMUTE',

	/**
	 * @description Pause video
	 * @type {PageAction.PAUSE}
	 */
	PAUSE = 'PageAction.PAUSE',

	/**
	 * @description Play (resume) video
	 * @type {PageAction.PLAY}
	 */
	PLAY = 'PageAction.PLAY',

	/**
	 * @description Request to initialize plugins.
	 * @type {PageAction.INITIALIZE_PLUGINS}
	 */
	INITIALIZE_PLUGINS = 'PageAction.INITIALIZE_PLUGINS',

}